import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="bg-paper px-4 py-16 sm:px-6 sm:py-24" data-id="element-109" data-mp="1clpjan0xo2ti">
      <div className="mx-auto max-w-6xl" data-id="element-110" data-mp="18kds4d2ev9j7">
        <SectionHeading eyebrow="Your complete clinical resource collection" title="The 6 Volumes Are Just the Beginning" intro="I also created five specialized resources to help you turn the information into practical reference materials." data-id="element-111" data-mp="18lfevesshkgr" />

        <div className="mt-12 space-y-16 sm:space-y-24" data-id="element-112" data-mp="1w7u8qigbdfub">
          {bonuses.map((b, i) => <article key={b.label} className="grid items-center gap-6 lg:grid-cols-2 lg:gap-14" data-id="element-113" data-mp="1r9am0ftwc00w" data-mpi={i}>
              <div className={`-mx-4 sm:mx-0 ${i % 2 === 1 ? "lg:order-2" : ""}`} data-id="element-114" data-mp="kuruvv5ln4du">
                <img src={b.image} alt={`${b.title} mockup`} className="block w-full" loading="lazy" data-id="element-115" data-mp="funlep33z9x4" />
              </div>
              <div data-id="element-116" data-mp="1eu6imuxvshmk">
                <div className="flex flex-wrap items-center gap-2" data-id="element-117" data-mp="1erkb2vazq24c">
                  <span className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 font-display text-sm font-black uppercase tracking-wider text-white" style={{
                backgroundColor: b.accent
              }} data-id="element-118" data-mp="1jrghf175u5n2">
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="w3fec7sr3hf1" />
                    Bonus {i + 1}
                  </span>
                  <span className="text-sm font-bold uppercase tracking-wide text-muted" data-id="element-120" data-mp="10uxe4sj1fbyf">{b.label}</span>
                </div>
                <h3 className="mt-4 font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-121" data-mp="n41zezluy0mx">{b.title}</h3>
                <p className="mt-4 text-lg leading-relaxed text-ink/85" data-id="element-122" data-mp="r1pzeh2eqjlo">{b.intro}</p>
                {b.bullets.length > 0 && <ul className="mt-4 space-y-2.5" data-id="element-123" data-mp="i3xk3cworbya">
                    {b.bullets.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-ink sm:text-lg" data-id="element-124" data-mp="2jt3hma2l4q1p">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                  color: b.accent
                }} aria-hidden="true" data-id="element-125" data-mp="2f1lcd9tj43ax" />
                        {item}
                      </li>)}
                  </ul>}
                <p className="mt-5 text-base font-medium leading-relaxed text-muted" data-id="element-126" data-mp="262zznvaqnii2">{b.outro}</p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-20 max-w-3xl rounded-3xl bg-white p-6 sm:p-12" data-id="element-127" data-mp="2ypkmqjk6l8ft">
          <h3 className="text-center font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-128" data-mp="2tq8307olwhhg">
            A Structured Approach for the Musculoskeletal Cases You Encounter
          </h3>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink/85" data-id="element-129" data-mp="1ic418fbs1p1u">
            <p data-id="element-130" data-mp="1dchp697oqeum">
              Whether you’re reviewing a patient with back pain, shoulder discomfort, knee symptoms, or an unfamiliar clinical
              presentation, the Musculoskeletal Clinical Pathway™ gives you a collection of educational references designed
              to help organize your assessment process.
            </p>
            <p data-id="element-131" data-mp="1d5pc8t1ytbk2">
              You’ll have a structured framework, a red-flag reference, regional assessment resources, reasoning worksheets,
              and educational cases to review.
            </p>
            <p className="font-semibold text-ink" data-id="element-132" data-mp="1ly94nbrnyjwg">The purpose isn’t to make every patient fit the same pathway.</p>
            <p data-id="element-133" data-mp="1qwkidxl2xejy">
              It’s to help you approach each patient with a clearer process while remaining attentive to individual
              presentation, clinical uncertainty, professional scope, and the need for additional evaluation when appropriate.
            </p>
          </div>
          <SectionCta label="Get All 6 Volumes + 5 Bonuses" data-id="element-134" data-mp="1ks1zf4s0b7q" />
        </div>
      </div>
    </section>;
}